export default __webpack_public_path__ + "static/media/logout-icon.98765d8a.svg";